
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Modal',
  emits: ['close'],
  setup(props, { emit }) {
    const closeModal = ({ target }: { target: HTMLElement }) => {
      if (
        target.className.includes('modal modal-container') ||
        target.className.includes('af af-close')
      ) {
        emit('close');
      }
    };

    return {
      closeModal,
    };
  },
});
